<script>
export default {
  name: "OfertText"
}
</script>

<template>
<div>
  <div class="info-message">
    1. Настоящим Клиент выражает свое согласие с обработкой переданных его персональных данных в целях: проверки Оператором Сервиса и Оператором ЭДС сведений (Операторы), указанных в данном Заявлении; принятия решений о заключении договора (ов); предоставления информации организациям, уполномоченным (в силу закона, договора или любым иным образом) на проведение проверок и/или анализа деятельности Операторов, а также на осуществление иных форм контроля за деятельностью Операторов, для целей осуществления ими указанных действий. Данное согласие действует до даты его отзыва Клиентом путем направления Операторам письменного сообщения об указанном отзыве в произвольной форме, если иное не установлено законодательством Российской Федерации.
  </div><br>
  <div class="info-message">
    2. Клиент подтверждает, что он прочитал, понял и соглашается с условиями Пользовательского соглашения об использовании сервиса ImPay, опубликованного по адресу https://app.impay.ru/
  </div><br>
  <div class="info-message">
    3. Клиент ознакомился и полностью согласен с СОГЛАШЕНИЕМ ОБ ИСПОЛЬЗОВАНИИ ЭЛЕКТРОННОГО СРЕДСТВА ПЛАТЕЖА «МОНЕТА.РУ» И О ПЕРЕВОДЕ ЭЛЕКТРОННЫХ ДЕНЕЖНЫХ СРЕДСТВ размещенным по адресу https://www.moneta.ru/info/public/users/nko/monetaoffer.pdf и тарифами НКО https://www.moneta.ru/info/public/users/nko/impay-ul.pdf
  </div><br>
  <div class="info-message">
    4. Клиент подтверждает переданную им информацию.
  </div><br>
</div>
</template>

<style scoped>
.info-message {
  font-size: 26px;
  word-wrap: break-word;

}
</style>
